import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import "@/i18n";
import App from "@/App";
import { installAdminAuth } from "@/lib/adminAuth";

// Sprint 157 — abans de res: el servidor ja no respon /api/admin/* sense token
installAdminAuth();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
